module.exports = __webpack_public_path__ + "img/satna.7a6fcc6.svg";